import { useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import TransTable from "../../common/TransTable";
import _ from "lodash";
import { Box, Button, IconButton, Switch, Typography } from "@mui/material";
import { PageTitle } from "../../common/PageTitle";
import { useDispatch } from "react-redux";
import { getAllUsers } from "../../../service";
import { Config } from "../../../utils/commonFuctions/Token";
import { utcTimetoLocalTimeWithzone } from '../../common/TransForm/Localdateformater';

import { setJackpots, setJackpotsDetails, } from "../../../redux/action";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { base_url } from "../../backendurl/url";
import { useState } from "react";
import UpdatePopup from "../../Leagues/UpdatePopup";
import { RefreshToken } from "../../../utils/commonFuctions/RefreshToken";
import { Notification } from "../../common/Notification";

export const Jackpots = () => {
    const navigate = useNavigate();
    const [jackPotData, setJackPotData] = useState([]);
    const [notification, setnotification] = useState(false)
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
      // Server-side pagination states
      const [totalCount, setTotalCount] = useState(0);
      const [currentPage, setCurrentPage] = useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(10);
      const [sortOrder, setSortOrder] = useState('');
      const [sortBy, setSortBy] = useState('');
    const dispatch = useDispatch();

    const JackpotColumn = () => [
        {
            key: "jackpot_id",
            label: "Jackpot ID",
            align: "left",
            fontSize: "15px",

            valueRenderer: (data) => {
                return (
                    <Button
                        component={Typography}
                        style={{ color: "#3C50E0", textDecoration: "underline" }}
                        onClick={() => navigate(`jackpots/details/${data.id}`, { state: { jackpotsdetails: data } })}
                    >
                        {data["jackpot_id"]}
                    </Button>
                );
            },

        },
        {
            key: "round_id",
            label: "Round ID",
            align: "left",
            fontSize: "15px",
            valueRenderer: (data) => {
                return <Typography> {data['round_id'] || '—'}</Typography>;
            },
        },
        {
            key: "league_name",
            label: "League Name",
            align: "left",
            fontSize: "15px",
            valueRenderer: (data) => {
                return <Typography> {data['league_name']}</Typography>;
            },
        },
        {
            key: "deadline",
            label: "Deadline",
            align: "left",
            fontSize: "15px",
            valueRenderer: (data) => {
                let date = utcTimetoLocalTimeWithzone(data["deadline"]);
                const [datePart,timePart] = date.split(', ');
                return <Typography> {datePart}  ,  {timePart}</Typography>;
            },
        },
        {
            key: "status",
            label: "Status",
            align: "left",
            fontSize: "15px",
            valueRenderer: (data) => {
                return <Typography> {data['status']}</Typography>;
            },
        },
    ];




    const getJackpots = useCallback(async (page = 1, limit = 10, orderBy = '', order = '') => {
        setLoading(true)
        try {
            // Build query parameters
      let queryParams = `page=${page}&limit=${limit}`;
      
      // Add sorting parameters if provided
      if (orderBy && order) {
        // queryParams += `&ordering=${order === 'desc' ? '-' : ''}${orderBy}`;
        queryParams += `&sort_by=${orderBy}&order=${order !== 'desc' ? 'desc' : 'asc'}`;

      }
       // console.log(`${base_url}/api/pot/jackpot?${queryParams}`, "queryParamsjackpot")

           // const response = await Axios.get(`${base_url}/api/pot/jackpot`, Config);
      const response = await Axios.get(`${base_url}/api/pot/jackpot?${queryParams}`, Config);

            console.log(response, "Jackpot")
            if (response?.status == 200) {
                setJackPotData(response?.data?.results)
                setTotalCount(response?.data?.count); 
                setLoading(false)
            }
        }
        catch (error) {
            RefreshToken(error, setErrorMessage, setnotification)
        }
    }, []);

      // Handle pagination change from TransTable
      const handlePageChange = useCallback((page, rowsPerPage) => {
        setCurrentPage(page);
        setRowsPerPage(rowsPerPage);
        // API pages usually start from 1, but MUI pagination starts from 0
        getJackpots(page + 1, rowsPerPage, sortBy, sortOrder);
      }, [sortBy, sortOrder, getJackpots]);
    
      // Handle sorting change from TransTable
      const handleSortChange = useCallback((orderBy, order) => {
        setSortBy(orderBy);
        setSortOrder(order);
        // Reset to first page when sorting changes
        setCurrentPage(0);
        getJackpots(1, rowsPerPage, orderBy, order);
      }, [rowsPerPage, getJackpots]);

    const gotoAddUser = () => {
        navigate("add");
    };

  useEffect(() => {
    getJackpots(1, 10); // Initial load
  }, []);

    return (
        <>
            <Box>
                <TransTable
                    showSearch={false}
                    checkbox={false}
                    columns={JackpotColumn()}
                    rows={jackPotData}
                    addBtnAction={gotoAddUser}
                    isLoading={loading}
                      // Server-side pagination props
          serverSide={true}
          totalCount={totalCount}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          onPageChange={handlePageChange}
          onSortChange={handleSortChange}
                />
                <Notification message={errorMessage} setopen={setnotification} type={'error'} show={notification} />

            </Box>
        </>
    );
}